import React from 'react';

interface Props {
  videoId: string;
  autoPlay?: boolean;
  controlsVisibleOnLoad?: boolean;
  endVideoBehavior?: string;
  fitStrategy?: string;
  fullscreenButton?: boolean;
  fullscreenOnRotateToLandscape?: boolean;
  muted?: boolean;
  playbar?: boolean;
  playButton?: boolean;
  playerColor?: string;
  playPauseNotifier?: boolean;
  playSuspendedOffScreen?: boolean;
  settingsControl?: boolean;
  silentAutoPlay?: string;
  smallPlayButton?: boolean;
  videoFoam?: boolean;
  volumeControl?: boolean;
}

const WistiaVideoBanner = ({
  videoId,
  autoPlay = true,
  controlsVisibleOnLoad = false,
  endVideoBehavior = 'loop',
  fitStrategy = 'none',
  fullscreenButton = false,
  fullscreenOnRotateToLandscape = false,
  muted = true,
  playbar = false,
  playButton = false,
  playerColor = '0075c9',
  playPauseNotifier = true,
  playSuspendedOffScreen = true,
  settingsControl = false,
  silentAutoPlay = 'allow',
  smallPlayButton = false,
  videoFoam = true,
  volumeControl = false,
}: Props) => {
  return (
    videoId && (
      <div className="wistia_responsive_padding relative pt-[56.25%]">
        <div className="wistia_responsive_wrapper absolute left-0 top-1/2 m-0 h-full w-full">
          <div
            className={`wistia_embed wistia_async_${videoId} autoPlay=${autoPlay} controlsVisibleOnLoad=${controlsVisibleOnLoad} endVideoBehavior=${endVideoBehavior} fitStrategy=${fitStrategy} fullscreenButton=${fullscreenButton} fullscreenOnRotateToLandscape=${fullscreenOnRotateToLandscape} muted=${muted} playbar=${playbar} playButton=${playButton} playerColor=${playerColor} playPauseNotifier=${playPauseNotifier} playSuspendedOffScreen=${playSuspendedOffScreen} settingsControl=${settingsControl} silentAutoPlay=${silentAutoPlay} smallPlayButton=${smallPlayButton} videoFoam=${videoFoam} volumeControl=${volumeControl} h-full w-full`}
          ></div>
        </div>
      </div>
    )
  );
};

export default WistiaVideoBanner;
